import { Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import rightArrowIcon from './icons/rightArrow.svg';
import { navItemsType } from './Navigation';
import {
  Indicator,
  StyledNavLinkItem,
  StyledNavLinkWithSubItem,
  StyledNavMenuButton,
} from './styled';

function checkLinkIsSelected(link: navItemsType, activeHref: string): boolean | undefined {
  // function to check if link has matchingpaths, and if they match current href.
  // otherwise check if the links path matches current href.
  const linkHasMatchingPaths = link.matchingPaths;
  return linkHasMatchingPaths ? link.matchingPaths?.includes(activeHref) : link.href === activeHref;
}
function checkSubmenuContainsActiveHref(submenu: any[], activeHref: string) {
  // check if submenu contains current active href
  const submenuHrefsArray = submenu.map((item) => item.href);
  return submenuHrefsArray.includes(activeHref);
}

export default function NavLinkItem({
  link,
  navIsCollapsed,
  activeHref,
  setActiveHref,
  setNavIsCollapsed,
  setUserHasCollapsed,
  closeMobileMenu,
}: {
  link: navItemsType;
  navIsCollapsed: boolean;
  activeHref: string;
  setActiveHref: (arg: string) => void;
  setNavIsCollapsed: (arg: boolean) => void;
  setUserHasCollapsed: (arg: boolean) => void;
  closeMobileMenu?: () => void;
}) {

  const [subMenuOpen, setSubMenuOpen] = useState(false);

  const navigate = useNavigate();
  const linkIsSelected = checkLinkIsSelected(link, activeHref);

  function handleLinkClick(href: string) {

    // DO NOT REMOVE THESE LINES OR NAVIGATION WONT WORK.
    setActiveHref(href);
    navigate(href);
    closeMobileMenu && closeMobileMenu();
  }

  useEffect(() => {
    // close submenu if nav is collapsed while submenu is open.
    if (navIsCollapsed) {
      setSubMenuOpen(false);
    }
  }, [navIsCollapsed]);

  function handleSubmenuParentClick(e: any, subMenu?: navItemsType[]) {
    if (navIsCollapsed) {
      // open nav and always expand submenu if nav collapsed
      const bodyEl = document.querySelector('body');
      bodyEl?.classList.remove('--nav-collapsed');

      setNavIsCollapsed(false);
      setUserHasCollapsed(false);
    }
    if (subMenu) {
      setSubMenuOpen(!subMenuOpen);
      const activeSubMenues = subMenu.filter(link => !link.hidden)
      if (activeSubMenues.length > 0) {
        setActiveHref(activeSubMenues[0].href);
        navigate(activeSubMenues[0].href);
      }
    }
  }

  return link.submenu ? (
    <StyledNavLinkWithSubItem>
      <StyledNavMenuButton
        className='nav-collapse'
        onClick={(e) => {
          handleSubmenuParentClick(e, link.submenu);
        }}
        id={link.href.split('/')[1]}
      >
        {checkSubmenuContainsActiveHref(link.submenu, activeHref) && <Indicator />}
        <Tooltip
          placement="right"
          title={link.name}
          overlayStyle={!navIsCollapsed ? { display: 'none' } : {}} // dont display tooltip if open.
        >
          <span
            className={`${checkSubmenuContainsActiveHref(link.submenu, activeHref) ? '--highlight' : ''
              }`}
          >
            <link.icon />
          </span>
        </Tooltip>
        {!navIsCollapsed && link.name}
        <img
          src={rightArrowIcon}
          alt="arrow"
          className="arrow"
          style={{
            transform: subMenuOpen && !navIsCollapsed ? 'rotate(90deg)' : 'rotate(0deg)',
          }}
        />
      </StyledNavMenuButton>

      {subMenuOpen && (
        <ul className="submenu-parent" style={{ height: navIsCollapsed ? '0' : 'initial' }}>
          {link.submenu.filter(link => !link.hidden).map((submenuItem, index) => {
            const submenuLinkIsSelected = checkLinkIsSelected(submenuItem, activeHref);

            return (
              <li key={`submenu-${index}`}>
                <StyledNavMenuButton
                  onClick={() => {
                    handleLinkClick(submenuItem.href);
                  }}
                  className={`submenu-button ${submenuLinkIsSelected ? 'selected' : ''}`}
                  id={submenuItem.href.split('/')[1]}
                >
                  <Tooltip
                    placement="right"
                    title={submenuItem.name}
                    overlayStyle={!navIsCollapsed ? { display: 'none' } : {}} // dont display tooltip if open.
                  ></Tooltip>
                  {!navIsCollapsed && submenuItem.name}
                </StyledNavMenuButton>
              </li>
            );
          })}
        </ul>
      )}
    </StyledNavLinkWithSubItem>
  ) : (
    <StyledNavLinkItem>
      <StyledNavMenuButton
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            handleLinkClick(link.href);
          }
        }}
        onClick={() => {
          handleLinkClick(link.href);
        }}
        className={linkIsSelected ? 'selected' : ''}
        id={link.href.split('/')[1]}
      >
        {linkIsSelected && <Indicator />}
        <Tooltip
          placement="right"
          title={link.name}
          overlayStyle={!navIsCollapsed ? { display: 'none' } : {}} // dont display tooltip if open.
        >
          <span>
            <link.icon />
          </span>
        </Tooltip>
        {!navIsCollapsed && link.name}
      </StyledNavMenuButton>
    </StyledNavLinkItem>
  );
}
